
export enum ClaimNoteVisibilityCd {
	CLAIMS_DEPT = 'ClaimsDept',
	EXTERNAL = 'External',
	XPO = 'XPO'}

